import {AppActions} from '../../types';
import {getUserCreditAmount as getUserCreditAmountApi} from '../../api/cargo/User';
import {fetchError, fetchStart} from './Common';
import {Dispatch} from 'redux';
import {UPDATE_USER_CREDIT} from '../../types/actions/Auth.actions';
import IapiAuthDetails from '../../shared/Interfaces/apiAuthDetails';

const authInformation = (userDetailID: number): IapiAuthDetails => ({
  CallerUserDetailID: userDetailID,
  CallerFormID: null,
});

export const getCreditAmount = (userDetailID: any, cb?: Function) => {
  return async (dispatch: Dispatch<AppActions | any>) => {
    dispatch(fetchStart());
    try {
      await getUserCreditAmountApi(
        authInformation(userDetailID),
        (err: any, data: any) => {
          if (!err) {
            if (cb) cb(userDetailID);
            dispatch({
              type: UPDATE_USER_CREDIT,
              payload: {
                credit: data?.Data?.Credit || 0,
                Balance: data?.Data?.Balance || 0,
                currency: data?.Data?.CurrencyID || null,
              },
            });
          } else {
            console.error(err);
          }
        },
      );
    } catch (err: any) {
      dispatch(fetchError(err.response.data.error));
    }
  };
};
